export default "__VITE_ASSET__DJWUFDcO__"